import React from 'react';
import { ChevronRightIcon, PackageCheckIcon } from 'lucide-react';
import { NowOrderStatus, useStore } from '../../lib/store';
interface NowActiveOrderBannerProps {
  onTrack: () => void;
}
const statusCopy: Record<NowOrderStatus, string> = {
  confirmed: 'Your order is confirmed',
  'pharmacist-review': 'A pharmacist is reviewing your order',
  preparing: 'Your order is being prepared',
  packed: 'Your order is packed and ready',
  'out-for-delivery': 'Your courier is on the way',
  delivered: 'Your order has been delivered'
};
export function NowActiveOrderBanner({
  onTrack
}: NowActiveOrderBannerProps) {
  const activeNowOrder = useStore(state => state.activeNowOrder);
  if (!activeNowOrder) return null;
  return <section className="rounded-xl border border-brand-border bg-white p-4 shadow-sm" aria-label="Active order" data-id="element-4175" data-mp="2xiqszryblit8">
      <div className="flex items-center gap-3" data-id="element-4176" data-mp="202bcv9ndu1jq">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand-light text-brand" data-id="element-4177" data-mp="2514qd22o5sjw">
          <PackageCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-4178" data-mp="3eywjrn64prkm" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-4179" data-mp="3a0cylozd0jtb">
          <p className="text-xs font-semibold text-brand-muted" data-id="element-4180" data-mp="3a1ehugqj4cm4">NOW 120 · {activeNowOrder.id}</p>
          <p className="truncate text-sm font-bold text-brand-ink" data-id="element-4181" data-mp="358lh03y6lofb">{statusCopy[activeNowOrder.status]}</p>
          <p className="mt-0.5 text-xs text-brand-muted" data-id="element-4182" data-mp="318azbu1119km">{activeNowOrder.estimatedDelivery}</p>
        </div>
        <button type="button" onClick={onTrack} className="inline-flex shrink-0 items-center gap-1 text-sm font-bold text-brand transition-colors duration-150 hover:text-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4183" data-mp="2w7dhjijxihjn">
          Track <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-4184" data-mp="2iaqklfrz7rdq" />
        </button>
      </div>
    </section>;
}